import React from 'react'
import classnames from 'classnames/bind'

import Layout from 'components/shared/Layout'
import LabelTitleText from 'components/shared/LabelTitleText'
import List from './List'

import css from './styles.module.scss'
import ContactForm from '../ContactForm'
import Image from 'components/shared/Image'

const cx = classnames.bind(css)

const PartnerDetails = ({
  className,
  location,
  services,
  intro,
  techStacks,
  embedForm,
  logo,
}) => {
  return (
    <Layout type="wrapper" className={cx(css.wrapper, className)}>
      <div className={css.innerWrapper}>
        <div className={css.Details}>
          <Image
            className={css.image}
            {...logo}
            alt={logo.media.data.attributes.alternativeText ?? 'logo-image'}
          />
          {intro && <LabelTitleText className={css.text} {...intro} />}
          <List
            services={services}
            location={location}
            techStacks={techStacks}
          />
        </div>
        {embedForm && embedForm.embedForm && (
          <ContactForm className={css.embedForm} {...embedForm.embedForm} />
        )}
      </div>
    </Layout>
  )
}

export default PartnerDetails
